import { FeedbackApi } from '../services/api';

export const feedbackApi = new FeedbackApi();
